var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        "dialog-class": "email-detail-modal",
        "hide-footer": "",
        title: _vm.formContext.data.subject || "",
        visible: _vm.show,
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("hidden")
        },
      },
    },
    [
      _c(
        "b-row",
        { staticClass: "email-detail-modal__content" },
        [
          _c(
            "b-col",
            {
              staticClass: "email-detail-modal__body-pane",
              attrs: { cols: "6" },
            },
            [
              !_vm.formContext.isLoaded
                ? _c(
                    "div",
                    { staticClass: "d-flex justify-content-center pt-5" },
                    [_c("csp-loading-indicator")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.formContext.isLoaded
                ? [
                    _vm.formContext.data.bodyHtml !== null &&
                    _vm.resolvedBodyHtml === null
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-content-center pt-5" },
                          [_c("csp-loading-indicator")],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.resolvedBodyHtml !== null
                      ? _c("iframe", {
                          staticClass: "email-detail-modal__iframe",
                          attrs: {
                            sandbox:
                              "allow-popups allow-popups-to-escape-sandbox",
                            srcdoc: _vm.resolvedBodyHtml,
                            width: "100%",
                          },
                        })
                      : _vm.formContext.data.bodyHtml === null
                      ? _c(
                          "pre",
                          { staticClass: "email-detail-modal__plaintext" },
                          [_vm._v(_vm._s(_vm.formContext.data.bodyPlaintext))]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "email-detail-modal__form-pane",
              staticStyle: { position: "relative" },
              attrs: { cols: "6" },
            },
            [
              _vm.formContext.isLoaded
                ? _c(
                    "dl",
                    { staticClass: "email-detail-modal__meta" },
                    [
                      _c(
                        "div",
                        { staticClass: "email-detail-modal__meta-item" },
                        [
                          _c("dt", [_vm._v("Betreff")]),
                          _vm._v(" "),
                          _c("dd", [
                            _vm._v(_vm._s(_vm.formContext.data.subject)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(
                        _vm.recipientTypeLabels,
                        function (recipientLabel, recipientType) {
                          return [
                            _vm.formContext.data.recipients &&
                            _vm.formContext.data.recipients[recipientType]
                              ? _c(
                                  "div",
                                  {
                                    key: recipientType,
                                    staticClass:
                                      "email-detail-modal__meta-item",
                                  },
                                  [
                                    _c("dt", [_vm._v(_vm._s(recipientLabel))]),
                                    _vm._v(" "),
                                    _c(
                                      "dd",
                                      _vm._l(
                                        _vm.formContext.data.recipients[
                                          recipientType
                                        ],
                                        function (recipient, index) {
                                          return _c(
                                            "span",
                                            { key: index },
                                            [
                                              _c("csp-text-with-tooltip", {
                                                attrs: {
                                                  text:
                                                    recipient.name ||
                                                    recipient.emailAddress,
                                                  tooltip:
                                                    recipient.emailAddress,
                                                },
                                              }),
                                              _vm._notLastRecipient(
                                                index,
                                                recipientType
                                              )
                                                ? [_vm._v(", ")]
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        }
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row email-detail-modal__meta-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 col-lg-4" },
                            [
                              _c("dt", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formContext.data.mailType === "sent"
                                      ? "Gesendet"
                                      : "Erhalten"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("dd", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDateTime(
                                      _vm.formContext.data.mailType === "sent"
                                        ? _vm.formContext.data.sentDateTime
                                        : _vm.formContext.data
                                            .receivedOutlookDateTime
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 col-lg-4" },
                            [
                              _c("dt", [_vm._v("Wichtigkeit")]),
                              _vm._v(" "),
                              _c("dd", [_vm._v(_vm._s(_vm.importanceLabel))]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 col-lg-4" },
                            [
                              _c("dt", [_vm._v("Anhänge")]),
                              _vm._v(" "),
                              _c("dd", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formContext.data.hasAttachments
                                      ? _vm.formContext.data.attachmentCount
                                      : "keine"
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.formContext.isLoaded ? _c("hr") : _vm._e(),
              _vm._v(" "),
              _c(
                "csp-desktop-info-card",
                {
                  staticStyle: { position: "relative" },
                  attrs: {
                    cols: 12,
                    "form-context": _vm.formContext,
                    icon: "inticon-autoclaim_assign",
                    "prevent-default-on-cancel": "",
                    "show-buttons": false,
                  },
                  on: {
                    "cancel-form": _vm._cancelEditMode,
                    save: _vm.saveEmailDetail,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-12 col-md-6",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Status",
                          options: _vm.statusOptions,
                          property: "status",
                          required: true,
                          type: "autocomplete",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-12 col-md-6",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Wiedervorlage",
                          "max-date": null,
                          "min-date": _vm.tomorrowString,
                          property: "reminderDate",
                          type: "datepicker",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-12 col-md-6",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Bearbeiter/in",
                          options: _vm.assignedUserOptions,
                          "options-loader": _vm.loadUserAssignmentOptions,
                          property: "assignedToUserId",
                          type: "autocomplete",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "display-value",
                            fn: function () {
                              return [
                                _vm.formContext.data.assignedToUserName
                                  ? _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.formContext.data
                                                .assignedToUserName
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "font-weight-bold text-muted",
                                      },
                                      [_vm._v("Kein Bearbeiter")]
                                    ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-12 col-md-6",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Kategorien",
                          property: "categories",
                          type: "text",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "display-value",
                            fn: function () {
                              return [
                                !_vm.formContext.data.categories ||
                                _vm.formContext.data.categories.length === 0
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "font-weight-bold text-muted",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                Keine Kategorien zugeordnet\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.formContext.data.categories,
                                  function (category) {
                                    return _c(
                                      "b-badge",
                                      {
                                        key: category.id,
                                        staticClass: "font-weight-bold mr-1",
                                        attrs: { variant: "secondary" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(category.displayName) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.formContext.isLoaded && _vm.formContext.isLoading === 0
                ? _c(
                    "div",
                    [
                      _c("p", { staticClass: "font-weight-bold mb-2" }, [
                        _vm._v("Zugeordnete Gutachten"),
                      ]),
                      _vm._v(" "),
                      !_vm.formContext.data.damageRecordAssignments ||
                      _vm.formContext.data.damageRecordAssignments.length === 0
                        ? _c("div", { staticClass: "text-muted mb-2" }, [
                            _vm._v(
                              "\n                    Keine Gutachten zugeordnet\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(
                        _vm.formContext.data.damageRecordAssignments,
                        function (assignment, index) {
                          return _c("div", { key: index }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.getAppraisalLink(
                                    assignment.vehicleDamageRecordId,
                                    assignment.damageRecordAppraisalId
                                  ),
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(assignment.appraisalNumber) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ])
                        }
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "mt-2",
                          attrs: { size: "sm", variant: "primary" },
                          on: { click: _vm.openAssignModal },
                        },
                        [
                          _vm._v(
                            "\n                    Gutachtenzuordnung\n                "
                          ),
                        ]
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("csp-email-damage-record-assign-modal", {
                attrs: {
                  "email-id": _vm.emailId,
                  "show-modal": _vm.showAssignModal,
                  subject: _vm.formContext.data.subject,
                },
                on: {
                  "assignments-changed": _vm.onAssignmentsChanged,
                  "update:showModal": function ($event) {
                    _vm.showAssignModal = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }